import { useContext } from "react";
import { AuthContext } from "contexts/AuthContext";
import Image from "components/Library/Image";

const NavBar = () => {
  const authContext = useContext(AuthContext);
  if (authContext?.user?.name) {
    return (
      <header className="navbar">
        <nav className="navbar__content">
          <span className="navbar__text">
            {authContext?.user?.name
              ? `${authContext.user.name} ${authContext.user.lastName}`
              : "¡Bienvenido!"}
          </span>
          <button
            className="navbar__logout"
            title="Cerrar sesión"
            onClick={() => {
              authContext.logOut();
            }}
          >
            <Image src={require("assets/img/logout.png")} alt="Logout" />
          </button>
        </nav>
      </header>
    );
  }
};

export default NavBar;
